import { gql } from "@apollo/client";

export const GET_ALL_CODIGO_POSTAL = gql`
query GetAllCodigoPostal(
    $skip: Int
    $take: Int
    $where: CodigoPostalFilterInput  
) {
    allCodigoPostal(skip: $skip, take: $take, where: $where )
    {
        items{
            idCodigoPostal,
            cP,
            idProvincia,
            localidad,
            idTipoZona,
            idProvinciaNavigation {
              idProvincia,
              descripcion
            },
            idTipoZonaNavigation {
              idTipoZona,
              descripcion
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;